import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiArrowLeftThin } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { BaseBreadcrumbs } from '@mgm/common/components/base';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { BASE_COLORS } from '@mgm/common/utils';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { PAGES_ANALYTICS_TITLES, QUERY_KEYS } from '../utils/enums';
import { PageHelmet } from '../components';
import { ProductExchangesView } from '../features/orders/Orders/components/ProductExchangesView';
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore';
import { getSelectedOrder } from '../store/orders/selectors';
import { ROUTES } from '../data';
import { ordersActions } from '../store/orders/slice';

const OrdersPage = () => {
  const { t } = useTranslation(['commissions', 'orders']);
  const selectedOrder = useAppSelector(getSelectedOrder);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const navigateToOrders = () => {
    const cachedData = queryClient.getQueryData([QUERY_KEYS.ORDERS.GET_ORDERS]);

    dispatch(ordersActions.setCameFromProductExchanges(!!cachedData));
    navigate(ROUTES.COMMISSION_SALES);
  };

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.ORDERS}>
      <Container
        sx={{
          px: { xs: 0, lg: 2 },
        }}
        maxWidth={false}
      >
        <BaseBreadcrumbs
          heading={t('productExchanges', { ns: 'orders' })}
          links={[
            { name: `${t('orderId', { ns: 'orders' })}: ${selectedOrder.id}` },
          ]}
          action={(
            <Stack direction="row" justifyContent="flex-end">
              <Link
                underline="none"
                component="button"
                sx={{
                  color: BASE_COLORS.primary,
                }}
                onClick={navigateToOrders}
              >
                <Box pb={3} display="flex" justifyContent="start">
                  <Icon className="mr-1" path={mdiArrowLeftThin} size={1} />
                  {t('backToCommissions', { ns: 'commissions' })}
                </Box>
              </Link>
            </Stack>
        )}
        />
        <ProductExchangesView />
      </Container>
    </PageHelmet>
  );
};

export default OrdersPage;
